import * as React from "react";

interface Props {
    header: string,
    box?: any,
    onSave?: any,
    onCancel?: any
}

interface State {

}

export default class ModalRegistrazione extends React.Component<Props, State> {

    render() {

        const { box, header } = this.props;

        const modalDialogClassname = (box !== undefined && box !== null) ? "modal-dialog has-box" : "modal-dialog";
        return (
            <div className="modal_registrazione">
                <div className="modal fade in">
                    <div className={modalDialogClassname}>
                        {
                            box !== undefined &&
                            box !== null &&
                            <div className="modal-box">
                                {this.props.box}
                            </div>
                        }
                        {
                            header !== undefined &&
                            header !== null &&
                            <div className="modal-header">
                                {this.props.header}
                            </div>
                        }
                        <div className="modal-body">
                            {this.props.children}
                        </div>
                        <div className="modal-right-footer">
                            <button type="button" className="btn btn-default btn-no" onClick={this.props.onCancel}>Annulla</button>
                            <button type="button" className="btn btn-default btn-si" onClick={this.props.onSave}>Salva</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/frontend/modals/ModalRegistrazione.tsx